import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SnackbarService } from './snackbar.service';
import { IErrorResponse } from '../models/error';
import { SnackbarType } from '../models/snackbar-type.enum';
import { AuthService } from './auth.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private _snackbarService: SnackbarService,
    private _authService: AuthService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipErrorHandler = request.headers.get('X-Skip-Error-Handler') === 'true';
    const req = request.clone();

    return next.handle(req).pipe(
      catchError((err: IErrorResponse) => {
        if (skipErrorHandler) {
          return throwError(() => err); // Repassa o erro para ser tratado localmente
        }

        if (err instanceof HttpErrorResponse) {
          if (err.status >= 500 || err.status === 405) {
            this._snackbarService.openSnackBar(
              'Erro interno do servidor, favor entrar em contato com o suporte.',
              SnackbarType.Danger
            );
            throw new Error(err.message);
          }

          if (err.status === 404) {
            this._snackbarService.openSnackBar(
              'Erro ao buscar informações, favor entrar em contato com o suporte.',
              SnackbarType.Danger
            );
            throw new Error(err.message);
          }

          if (
            err.status === 401 &&
            err.statusText.toLowerCase() === 'unauthorized'
          ) {
            this._snackbarService.openSnackBar(
              'Autenticação expirada ou não autorizada, favor autenticar novamente.',
              SnackbarType.Danger
            );
            this._authService.setActiveRouteAndTryLogin();
            throw new Error(err.message);
          }

          if (err.status === 403 || err.status === 0) {
            this._snackbarService.openSnackBar(
              'Autenticação expirada ou não autorizada, favor autenticar novamente.',
              SnackbarType.Danger
            );
            this._authService.setActiveRouteAndTryLogin();
          }

          if (err.status === 400) {
            const error: any = err.error;

            const message =
              (error && error.message) ??
              (typeof error === 'string' ? error : (err.message ?? err.error.Message));

            this._snackbarService.openSnackBar(
              message,
              SnackbarType.Danger
            );

            throw new Error(message);
          }
        }

        return new Observable<HttpEvent<any>>();
      })
    );
  }
}
